import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User, UserDetail } from '@app/_models';
import { BaseService } from './base.service';
import { StorageKey } from '@app/_models/enum';


@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    super();
    this.userSubject = new BehaviorSubject<User>(this.getSessionStorage(StorageKey.Identity));
    this.user = this.userSubject.asObservable();
  }

  httpOptions_object = {
    headers: new HttpHeaders().append('key', 'value')
  }
  public get userValue(): User {
    return this.userSubject.value;
  }

  login(username, password) {
    const pass = this.encryptPass(password);
    return this.http.post<User>(`${environment.apiUrl}/login/authenticate`, { username, password: pass })
      .pipe(map(user => {
        if (user && user.isSuccess == true) {
          this.userSubject.next(user);
          this.startRefreshTokenTimer();
          // store user details and jwt token in sessionStorage to keep user logged in between page refreshes
          this.setSessionStorage(StorageKey.Identity, user)
        }
        return user;
      }));
  }

  logout() {
    // remove user from local storage and set current user to null
    sessionStorage.clear();
    this.userSubject.next(null);
    this.stopRefreshTokenTimer();
    this.router.navigate(['/account/login']);
  }

  //fogetpassword(username) {

  //  return this.http.post<string>(`${environment.apiUrl}/login/ForgetPassword`, { UserName: username,Password:'' })
  //    .pipe(map(result => {
  //      return result;
  //    }));
  //}

  //fogetpassword(username): Promise<any> {
  //  return this.http.post<any>(`${environment.apiUrl}/login/ForgetPassword`, { UserName: username, Password: '' }, this.httpOptions_object).toPromise();
  //}

  fogetpassword(username) {
    return this.http.post<any>(`${environment.apiUrl}/login/ForgetPassword`,username);
  }
  //-----------------------------------------------
  refreshToken() {
    const uId = this.userSubject.value.uId;
    return this.http.post<any>(`${environment.apiUrl}/login/RefreshToken?uId=${uId}`, uId)
      .pipe(map((user) => {
        sessionStorage.setItem('user', JSON.stringify(user));
        this.userSubject.next(user);
        this.startRefreshTokenTimer();
        return user;
      }));
  }

  private refreshTokenTimeout;
  private startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(this.userValue.token.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date((jwtToken.exp * 1000) - 60000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }
  //-----------------------------------------------

  register(user: User) {
    return this.http.post(`${environment.apiUrl}/users/register`, user);
  }

  getAll() {
    return this.http.get<User[]>(`${environment.apiUrl}/users`);
  }

  getById(id: string) {
    return this.http.get<User>(`${environment.apiUrl}/users/${id}`);
  }

  getUsers(): Observable<UserDetail[]> {
    return this.http.get<UserDetail[]>(`${environment.apiUrl}/account/get-users`)
  }


  getByUID(userGuid: any): Observable<UserDetail> {
    return this.http.get<UserDetail>(`${environment.apiUrl}/account/get-user-registration/${userGuid}`);
  }
  createUserFromRequest(payLoad: any) {
    return this.http.post<boolean>(`${environment.apiUrl}/account/update-user-from-request`, payLoad);
  }

  //USER TOKEN VALIDATION, RESET PASSWORD AND CHANGE PASSWORD

  validTokenForResetPassword(token:any) {
    return this.http.post<any>(`${environment.apiUrl}/login/CheckIsValidEmailToken`, token);
  }

  ResetPassword(params) {
    return this.http.post<any>(`${environment.apiUrl}/login/ResetNewPassword`, params);
  }

  ChangePassword(params) {
    return this.http.post<any>(`${environment.apiUrl}/login/ChangePassword`, params);
  }

  //update(id, params) {
  //    return this.http.put(`${environment.apiUrl}/users/${id}`, params)
  //        .pipe(map(x => {
  //            // update stored user if the logged in user updated their own record
  //            if (id == this.userValue.uid) {
  //                // update local storage
  //                const user = { ...this.userValue, ...params };
  //                localStorage.setItem('user', JSON.stringify(user));

  //                // publish updated user to subscribers
  //                this.userSubject.next(user);
  //            }
  //            return x;
  //        }));
  //}

  //delete(id: string) {
  //    return this.http.delete(`${environment.apiUrl}/users/${id}`)
  //        .pipe(map(x => {
  //            // auto logout if the logged in user deleted their own record
  //            if (id == this.userValue.uid) {
  //                this.logout();
  //            }
  //            return x;
  //        }));
  //}
}
